var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32408 12.2171L2.05742 10.9504C1.54076 10.4337 1.54076 9.58371 2.05742 9.06705L3.32408 7.80036C3.54075 7.5837 3.71575 7.15869 3.71575 6.85869V5.067C3.71575 4.33367 4.31575 3.73369 5.04909 3.73369H6.84075C7.14075 3.73369 7.56575 3.55872 7.78242 3.34205L9.04908 2.07537C9.56574 1.5587 10.4158 1.5587 10.9324 2.07537L12.1991 3.34205C12.4158 3.55872 12.8407 3.73369 13.1407 3.73369H14.9324C15.6658 3.73369 16.2657 4.33367 16.2657 5.067V6.85869C16.2657 7.15869 16.4407 7.5837 16.6574 7.80036L17.9241 9.06705C18.4408 9.58371 18.4408 10.4337 17.9241 10.9504L16.6574 12.2171C16.4407 12.4337 16.2657 12.8587 16.2657 13.1587V14.9503C16.2657 15.6837 15.6658 16.2837 14.9324 16.2837H13.1407C12.8407 16.2837 12.4158 16.4587 12.1991 16.6754L10.9324 17.9421C10.4158 18.4587 9.56574 18.4587 9.04908 17.9421L7.78242 16.6754C7.56575 16.4587 7.14075 16.2837 6.84075 16.2837H5.04909C4.31575 16.2837 3.71575 15.6837 3.71575 14.9503V13.1587C3.71575 12.8504 3.54075 12.4254 3.32408 12.2171Z",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5L12.5 7.5",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 12.0833H12.0856",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91209 7.91667H7.91957",
    stroke: "CurrentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDiscount);
export default __webpack_public_path__ + "static/media/invoice-discount.2180b2849f2cf9c462100f449cef3a1e.svg";
export { ForwardRef as ReactComponent };